cityLeakR={
    "北京": 0.1551242722084437,
    "天津": 0.14947373109832043,
    "河北": 0.16281122561121983,
    "石家庄市": 0.18325621822545823,
    "晋州市": 0.046908734052993124,
    "新乐市": 0.08892128279883382,
    "唐山市": 0.1373168183200805,
    "滦州市": 0.10367892976588629,
    "遵化市": 0.08710801393728224,
    "迁安市": 0.1094488188976378,
    "秦皇岛市": 0.17684465104706917,
    "邯郸市": 0.15482619525205546,
    "武安市": 0.1016561964591662,
    "邢台市": 0.15801232455327444,
    "南宫市": 0.049217442661679295,
    "沙河市": 0.18346774193548387,
    "保定市": 0.1429333074354891,
    "涿州市": 0.08604159496533753,
    "安国市": 0.09872782150009873,
    "高碑店市": 0.5534377127297482,
    "白沟新城": 0.4228571428571429,
    "张家口市": 0.2145541033038856,
    "承德市": 0.2774488248085827,
    "平泉市": 0.170018281535649,
    "沧州市": 0.1289170963903213,
    "泊头市": 0.1,
    "任丘市": 0.07081556647055648,
    "黄骅市": 0.11564625850340136,
    "河间市": 0.10045238697350305,
    "廊坊市": 0.10525293755546451,
    "霸州市": 0.29554655870445345,
    "三河市": 0.1037344398340249,
    "衡水市": 0.16526972322509678,
    "深州市": 0.034559955225968934,
    "辛集市": 0.1399132321041215,
    "定州市": 0.14694940476190477,
    "山西": 0.09494124427253739,
    "太原市": 0.09161444170787224,
    "古交市": 0.07952410770194114,
    "大同市": 0.0644702166064982,
    "阳泉市": 0.13565936907429754,
    "长治市": 0.0949361638563533,
    "潞城市": 0.09146662966560289,
    "晋城市": 0.07203729030847805,
    "高平市": 0.07558290395522112,
    "朔州市": 0.07699578136886513,
    "晋中市": 0.14992905386230773,
    "介休市": 0.10558859624280184,
    "运城市": 0.057905995477965586,
    "永济市": 0.16574585635359115,
    "河津市": 0.11863387978142077,
    "忻州市": 0.12385857330848413,
    "原平市": 0.2058743169398907,
    "临汾市": 0.1399638336347197,
    "侯马市": 0.09324699352451433,
    "霍州市": 0.11544227886056972,
    "吕梁市": 0.11632835231028163,
    "孝义市": 0.1352154531946508,
    "汾阳市": 0.115,
    "内蒙古": 0.16867372329679456,
    "呼和浩特市": 0.1870573566084788,
    "包头市": 0.16680074343255014,
    "乌海市": 0.11124351218605948,
    "赤峰市": 0.13360186950372058,
    "通辽市": 0.1907096083525089,
    "霍林郭勒市": 0.07648183556405354,
    "鄂尔多斯市": 0.257237186558022,
    "呼伦贝尔市": 0.19099418732918805,
    "满洲里市": 0.1827956989247312,
    "牙克石": 0.1250853242320819,
    "扎兰屯市": 0.21937842778793418,
    "额尔古纳市": 0.07741935483870968,
    "根河市": 0.08042895442359249,
    "巴彦淖尔市": 0.1694128792031963,
    "乌兰察布市": 0.1519969080133986,
    "丰镇市": 0.10127586206896552,
    "乌兰浩特市": 0.27722772277227725,
    "阿尔山市": 0.10021786492374728,
    "二连浩特": 0.2100238663484487,
    "锡林浩特市": 0.11578112609040445,
    "辽宁": 0.23196444722316653,
    "沈阳市": 0.16741956328285967,
    "新民市": 0.5128922344525936,
    "大连市": 0.23398828657788498,
    "瓦房店市": 0.47636986301369866,
    "庄河市": 0.28901734104046245,
    "鞍山市": 0.22280570142535633,
    "海城市": 0.27283326855810336,
    "抚顺市": 0.23914218252004985,
    "本溪市": 0.2192142162987644,
    "丹东市": 0.22820717131474103,
    "东港市": 0.2711698482623593,
    "凤城市": 0.28711256117455136,
    "锦州市": 0.30003947887879984,
    "凌海市": 0.20507399577167018,
    "北镇市": 0.01040149781568546,
    "营口市": 0.2440115819952619,
    "盖州市": 0.2610628103115582,
    "大石桥市": 0.4840825754942307,
    "阜新市": 0.16648840859528008,
    "辽阳市": 0.446534782390945,
    "灯塔市": 0.38391224862888484,
    "盘锦市": 0.21925701288855193,
    "铁岭市": 0.1775571683308416,
    "调兵山市": 0.41369863013698627,
    "开原市": 0.39268521140566803,
    "朝阳市": 0.21500945062436091,
    "北票市": 0.5094206431799493,
    "凌源市": 0.20789473684210527,
    "葫芦岛市": 0.18758285461776403,
    "兴城市": 0.0036850006824075336,
    "吉林": 0.29047526162107995,
    "长春市": 0.30171330428954424,
    "榆树市": 0.2407494145199063,
    "德惠市": 0.1797752808988764,
    "吉林市": 0.19916610103752547,
    "蛟河市": 0.5676739299520553,
    "桦甸市": 0.2552083333333333,
    "舒兰市": 0.2507172551086129,
    "磐石市": 0.15440289505428226,
    "四平市": 0.00263777076716925,
    "双辽市": 0.20535714285714285,
    "辽源市": 0.19220809278845732,
    "通化市": 0.37546454914640864,
    "集安市": 0.3474945533769063,
    "白山市": 0.3424794098250027,
    "临江市": 0.12468827930174564,
    "松原市": 0.26506006888819594,
    "扶余市": 0.10139118132515916,
    "白城市": 0.38020519010259507,
    "洮南市": 0.06354515050167224,
    "大安市": 0.1920681113061882,
    "延吉市": 0.4786209333606912,
    "图们市": 0.2802400738688828,
    "敦化市": 0.21910212842067608,
    "珲春市": 0.1665588615782665,
    "龙井市": 0.618313953488372,
    "和龙市": 0.35039125431530493,
    "公主岭市": 0.6163644649647743,
    "梅河口市": 0.12560975609756098,
    "长白山保护开发区管理委员会": 0.04940711462450593,
    "黑龙江": 0.25312550005473416,
    "哈尔滨市": 0.28843483847904117,
    "尚志市": 0.0860563660666041,
    "五常市": 0.25,
    "齐齐哈尔市": 0.30543477931529717,
    "讷河市": 0.14484764542936288,
    "鸡西市": 0.43357805790275666,
    "虎林市": 0.2611764705882353,
    "密山市": 0.10714285714285714,
    "鹤岗市": 0.24891131862684762,
    "双鸭山市": 0.3632205724962896,
    "大庆市": 0.12711333750782716,
    "伊春市": 0.13659704686776153,
    "铁力市": 0.141747572815534,
    "佳木斯市": 0.27453062206314777,
    "同江市": 0.18,
    "富锦市": 0.10194500335345406,
    "抚远市": 0.21298892988929888,
    "七台河市": 0.2798640091320528,
    "牡丹江市": 0.48369330142160966,
    "海林市": 0.1702127659574468,
    "宁安市": 0.3477272727272727,
    "穆棱市": 0.1644349636330926,
    "绥芬河市": 0.3550277055073385,
    "东宁市": 0.3022508591065292,
    "黑河市": 0.31387308533916847,
    "北安市": 0.14033264033264034,
    "五大连池市": 0.09695652173913044,
    "绥化市": 0.10714285714285714,
    "安达市": 0.3116438356164384,
    "肇东市": 0.29301808628877435,
    "海伦市": 0.09765625,
    "上海": 0.16115601211844396,
    "江苏": 0.12664481601554203,
    "南京市": 0.11772872780914402,
    "无锡市": 0.15978326227609566,
    "江阴市": 0.05758059656523049,
    "宜兴市": 0.17136659436008678,
    "徐州市": 0.13620032399241103,
    "新沂市": 0.09971853638922397,
    "邳州市": 0.16150759641604986,
    "常州市": 0.11635308961044166,
    "溧阳市": 0.1415803240025247,
    "苏州市": 0.10456431609650933,
    "常熟市": 0.09097003798719785,
    "张家港市": 0.09876805437553102,
    "昆山市": 0.1082888139472709,
    "太仓市": 0.12309073693945408,
    "南通市": 0.1668151102526254,
    "海安市": 0.15161536642961765,
    "启东市": 0.18719926626101122,
    "如皋市": 0.13731387055922148,
    "海门市": 0.11000822772744148,
    "连云港市": 0.12532518332992656,
    "淮安市": 0.14831023504953614,
    "盐城市": 0.17075241622256346,
    "东台市": 0.12745074384871136,
    "扬州市": 0.11323317879533643,
    "仪征市": 0.08655891343742562,
    "高邮市": 0.2069580617557782,
    "镇江市": 0.10535830450648151,
    "丹阳市": 0.1588824403807378,
    "扬中市": 0.21465835992503673,
    "句容市": 0.29455878278757697,
    "泰州市": 0.11583609036770962,
    "兴化市": 0.09629101283880172,
    "靖江市": 0.039015361195682254,
    "泰兴市": 0.19005275209218445,
    "宿迁市": 0.11165884118568785,
    "浙江": 0.10756395413945427,
    "杭州市": 0.10532903036267953,
    "建德市": 0.1148936170212766,
    "宁波市": 0.099817299599449,
    "余姚市": 0.14032835810930358,
    "慈溪市": 0.242993548640823,
    "温州市": 0.12904905054174873,
    "瑞安市": 0.09507829977628636,
    "乐清市": 0.08434497262874226,
    "嘉兴市": 0.158134706060475,
    "海宁市": 0.09519506862306051,
    "平湖市": 0.03402849486547611,
    "桐乡市": 0.089435799990263,
    "湖州市": 0.11960433958701237,
    "绍兴市": 0.05791737803648487,
    "诸暨市": 0.11635052428581172,
    "嵊州市": 0.09121928454257618,
    "金华市": 0.1004258179730329,
    "兰溪市": 0.07955267681942105,
    "义乌市": 0.08538729202825729,
    "东阳市": 0.21926394171532648,
    "永康市": 0.17181300016176457,
    "衢州市": 0.0943185445260134,
    "江山市": 0.09130662935105824,
    "舟山市": 0.11823284446858591,
    "台州市": 0.10940046411110324,
    "玉环市": 0.07788046826863833,
    "温岭市": 0.1082271974413159,
    "临海市": 0.19875905938787214,
    "丽水市": 0.11212021978769732,
    "龙泉市": 0.09639176366805086,
    "安徽": 0.1386301130703234,
    "合肥市": 0.1233880269575528,
    "巢湖市": 0.06696844993141289,
    "芜湖市": 0.1730653859428879,
    "蚌埠市": 0.16464474975466142,
    "淮南市": 0.1746198561175843,
    "马鞍山市": 0.14202408917209125,
    "淮北市": 0.1712962962962963,
    "铜陵市": 0.11716559691912709,
    "安庆市": 0.13771822591917246,
    "潜山市": 0.0899972672147009,
    "桐城市": 0.10356094958655643,
    "黄山市": 0.16633211848587146,
    "滁州市": 0.15186958799420663,
    "天长市": 0.12335958005249344,
    "明光市": 0.06959798994974874,
    "阜阳市": 0.11956470715824608,
    "界首市": 0.08028545941123996,
    "宿州市": 0.11315712238661672,
    "六安市": 0.13644599303135888,
    "亳州市": 0.15535311820991402,
    "池州市": 0.18626041966082207,
    "宣城市": 0.12264477827998552,
    "宁国市": 0.10881506197525807,
    "福建": 0.16358315613855096,
    "福州市": 0.23746114579449543,
    "福清市": 0.23036491737633796,
    "厦门市": 0.10467169458810405,
    "莆田市": 0.15552704412661764,
    "三明市": 0.12173933494633297,
    "永安市": 0.07894056906109904,
    "泉州市": 0.157357555717109,
    "石狮市": 0.15796823759885464,
    "晋江市": 0.08901408450704225,
    "南安市": 0.14390639637638467,
    "漳州市": 0.17220355854174443,
    "龙海市": 0.12347826086956522,
    "南平市": 0.18036408006964255,
    "邵武市": 0.13300639697433067,
    "武夷山市": 0.1529025726321118,
    "建瓯市": 0.13082530590991928,
    "龙岩市": 0.16569964560330597,
    "漳平市": 0.18483135300881565,
    "宁德市": 0.17518288937287094,
    "福安市": 0.16998106748400904,
    "福鼎市": 0.13600145828691795,
    "江西": 0.14968363344105426,
    "南昌市": 0.16832759669895883,
    "景德镇市": 0.13979219562903417,
    "乐平市": 0.09295537205563273,
    "萍乡市": 0.19156066679907907,
    "九江市": 0.21566184223138118,
    "瑞昌市": 0.09209402018856175,
    "共青城市": 0.037786989795918366,
    "庐山市": 0.08540372670807453,
    "新余市": 0.09092406522813375,
    "鹰潭市": 0.12294318534616579,
    "贵溪市": 0.10318664643399089,
    "赣州市": 0.10152039303468124,
    "瑞金市": 0.0851063829787234,
    "吉安市": 0.14704658901830284,
    "井冈山市": 0.10155717761557179,
    "宜春市": 0.1285386686164379,
    "丰城市": 0.12463699475278253,
    "樟树市": 0.12720784116612216,
    "高安市": 0.12759493670886077,
    "抚州市": 0.18745367284362083,
    "上饶市": 0.1502426965830921,
    "德兴市": 0.19866071428571427,
    "山东": 0.1250637447311449,
    "济南市": 0.16061835464178334,
    "青岛市": 0.12511224488981443,
    "胶州市": 0.169709817942575,
    "平度市": 0.12898936170212766,
    "莱西市": 0.15459981405358467,
    "淄博市": 0.19172984484543903,
    "枣庄市": 0.19901283282039697,
    "滕州市": 0.1392156862745098,
    "东营市": 0.11248444579396408,
    "烟台市": 0.11056497739537789,
    "龙口市": 0.09365714445594696,
    "莱阳市": 0.11562548768158717,
    "莱州市": 0.09995147986414361,
    "蓬莱市": 0.06453923803321393,
    "招远市": 0.06398329080037948,
    "栖霞市": 0.10113636363636364,
    "海阳市": 0.09666570646694513,
    "潍坊市": 0.10719353590729633,
    "青州市": 0.10063430104903635,
    "诸城市": 0.0933605720122574,
    "寿光市": 0.060755113150322726,
    "安丘市": 0.10565604364053977,
    "高密市": 0.08218325432896735,
    "昌邑市": 0.1099246231155779,
    "济宁市": 0.10705156204564285,
    "曲阜市": 0.1,
    "邹城市": 0.09975098925843208,
    "泰安市": 0.09930924464427679,
    "新泰市": 0.06736304305985687,
    "肥城市": 0.09626825310978908,
    "威海市": 0.12539098720759775,
    "荣成市": 0.10730499380932729,
    "乳山市": 0.11077111383108935,
    "日照市": 0.12028681175380723,
    "莱芜市": 0.11796407185628742,
    "临沂市": 0.11798396402896603,
    "德州市": 0.14339385333198093,
    "乐陵市": 0.07929585282689716,
    "禹城市": 0.11907181369325856,
    "聊城市": 0.10647106109324758,
    "临清市": 0.15405447796308883,
    "滨州市": 0.10043508307820348,
    "邹平市": 0.09051160380875356,
    "菏泽市": 0.10133542812254517,
    "河南": 0.15039393086802336,
    "郑州市": 0.15518782961265326,
    "巩义市": 0.17857348586965288,
    "荥阳市": 0.10182975338106603,
    "新密市": 0.10991291515184123,
    "新郑市": 0.14340753424657535,
    "登封市": 0.10067114093959731,
    "开封市": 0.22371548229058397,
    "洛阳市": 0.13718111263383925,
    "偃师市": 0.11885467314964884,
    "平顶山市": 0.12093848262517133,
    "舞钢市": 0.10429341213280029,
    "汝州市": 0.07492354740061162,
    "安阳市": 0.1352950098589413,
    "林州市": 0.1841897233201581,
    "鹤壁市": 0.15247817904160577,
    "新乡市": 0.18773051742927535,
    "卫辉市": 0.10610156833457804,
    "辉县市": 0.11505273250239693,
    "焦作市": 0.17788732148163686,
    "沁阳市": 0.13333333333333333,
    "孟州市": 0.20931065353625786,
    "濮阳市": 0.06239565457366804,
    "许昌市": 0.10969986560537741,
    "禹州市": 0.1162139689578714,
    "长葛市": 0.13199665831244778,
    "漯河市": 0.15985750909449464,
    "三门峡市": 0.24882629107981222,
    "义马市": 0.08366965252485481,
    "灵宝市": 0.14432989690721648,
    "南阳市": 0.11456797404895311,
    "邓州市": 0.11464968152866242,
    "商丘市": 0.2038,
    "永城市": 0.09694619486185167,
    "信阳市": 0.16305034085369266,
    "周口市": 0.2724743966116128,
    "项城市": 0.14507042253521127,
    "驻马店市": 0.1455314156494675,
    "济源市": 0.1492483894058697,
    "湖北": 0.15799910149220756,
    "武汉市": 0.12366581865368124,
    "黄石市": 0.1718805821774181,
    "大冶市": 0.14203284509542832,
    "十堰市": 0.20679069922635107,
    "丹江口市": 0.055302156358150674,
    "宜昌市": 0.14742433102424324,
    "宜都市": 0.16432626232446967,
    "当阳市": 0.10937877105758556,
    "枝江市": 0.21031397584071007,
    "襄阳市": 0.3574788176855603,
    "老河口市": 0.16650813837916403,
    "枣阳市": 0.07139629462268414,
    "宜城市": 0.08235294117647059,
    "鄂州市": 0.11929707591199161,
    "荆门市": 0.17184242638771158,
    "钟祥市": 0.09947414548641542,
    "孝感市": 0.11768096702068195,
    "应城市": 0.11738648947951273,
    "安陆市": 0.3006875,
    "汉川市": 0.2953550992931673,
    "荆州市": 0.13373340603127726,
    "石首市": 0.12585049685911318,
    "洪湖市": 0.22998593649215932,
    "松滋市": 0.20606060606060606,
    "黄冈市": 0.2745955400087451,
    "麻城市": 0.2827592037651126,
    "武穴市": 0.09115281501340483,
    "咸宁市": 0.1932216338381714,
    "赤壁市": 0.17945780832378772,
    "随州市": 0.08455467869222097,
    "广水市": 0.26002834635287914,
    "恩施市": 0.2384804885900279,
    "利川市": 0.029595902105862264,
    "仙桃市": 0.21145119225037257,
    "潜江市": 0.26898638426626326,
    "天门市": 0.09386056191467222,
    "湖南": 0.14630210695003093,
    "长沙市": 0.10892242048248225,
    "宁乡市": 3.603473748693741e-05,
    "浏阳市": 0.051308726228621364,
    "株洲市": 0.1637982452764844,
    "醴陵市": 0.23232910898213677,
    "湘潭市": 0.20057436380602087,
    "湘乡市": 0.01090909090909091,
    "韶山市": 0.20706455542021923,
    "衡阳市": 0.1186966186966187,
    "耒阳市": 0.10527730490099453,
    "常宁市": 0.0967741935483871,
    "邵阳市": 0.3504979868616232,
    "武冈市": 0.09239130434782608,
    "岳阳市": 0.26518997966627794,
    "汨罗市": 0.412183926857755,
    "临湘市": 0.14934409687184663,
    "常德市": 0.13058585296038688,
    "津市市": 0.22719298245614036,
    "张家界市": 0.15513861663399608,
    "益阳市": 0.18769490654485985,
    "沅江市": 0.009523809523809525,
    "郴州市": 0.12000018412349163,
    "资兴市": 0.2393103448275862,
    "永州市": 0.13967622772707516,
    "怀化市": 0.14700014766900138,
    "洪江市": 0.25700567354136317,
    "娄底市": 0.11349157225563987,
    "冷水江市": 0.15824439321933342,
    "涟源市": 0.1750814332247557,
    "吉首市": 0.12711076553810788,
    "广东": 0.1339862607038512,
    "广州市": 0.13449452623558522,
    "韶关市": 0.1675035059362092,
    "乐昌市": 0.25745823863184836,
    "南雄市": 0.19391408114558473,
    "深圳市": 0.10660285908478088,
    "珠海市": 0.15116138093155732,
    "汕头市": 0.18060168109465857,
    "佛山市": 0.11289276453647139,
    "江门市": 0.13506156932942542,
    "台山市": 0.11122891676743828,
    "开平市": 0.10960240159224507,
    "鹤山市": 0.10847839965950203,
    "恩平市": 0.10819895182422898,
    "湛江市": 0.12904847262678318,
    "廉江市": 0.2970036219953902,
    "雷州市": 0.1714708056171471,
    "吴川市": 0.15960912052117263,
    "茂名市": 0.10381137048939963,
    "高州市": 0.25381758151052414,
    "化州市": 0.10499985979080789,
    "信宜市": 0.11304347826086956,
    "肇庆市": 0.13956593014701763,
    "四会市": 0.1530389156099694,
    "惠州市": 0.11775101066416313,
    "梅州市": 0.11845114271895266,
    "兴宁市": 0.40886854244347365,
    "汕尾市": 0.1169511576812574,
    "陆丰市": 0.10869565217391304,
    "河源市": 0.1383756609227568,
    "阳江市": 0.1771572437047522,
    "阳春市": 0.08603573792190602,
    "清远市": 0.12188511588988843,
    "英德市": 0.2579085281719559,
    "连州市": 0.11722272317403065,
    "东莞市": 0.12404841469403116,
    "中山市": 0.21797806013732143,
    "潮州市": 0.2733269096983248,
    "揭阳市": 0.09749071550616378,
    "普宁市": 0.31302816901408453,
    "云浮市": 0.18921257571387368,
    "罗定市": 0.11163337250293771,
    "广西": 0.1369159427150231,
    "南宁市": 0.1509144035584121,
    "柳州市": 0.15956804858021273,
    "桂林市": 0.1243491215209629,
    "荔浦市": 0.08736276988217638,
    "梧州市": 0.11101974028073765,
    "岑溪市": 0.17590729102335892,
    "北海市": 0.06878429733515995,
    "防城港市": 0.14599849844678786,
    "东兴市": 0.11331228070175439,
    "钦州市": 0.1488298313180717,
    "贵港市": 0.12787152606871827,
    "桂平市": 0.1414505283381364,
    "玉林市": 0.12598427234359677,
    "北流市": 0.08761682242990654,
    "百色市": 0.09571445908077933,
    "靖西市": 0.14838709677419354,
    "贺州市": 0.09827792288281907,
    "河池市": 0.14017506025624762,
    "来宾市": 0.13962946771786483,
    "合山市": 0.14736842105263157,
    "崇左市": 0.09773474607234199,
    "凭祥市": 0.12,
    "海南": 0.12433950476724294,
    "海口市": 0.15976380008005708,
    "三亚市": 0.04992107073950646,
    "三沙市": 0.13043478260869565,
    "儋州市": 0.19554794520547944,
    "五指山市": 0.17110266159695817,
    "琼海市": 0.05764685536403989,
    "文昌市": 0.0983221963017147,
    "万宁市": 0.22858519779340894,
    "东方市": 0.0423728813559322,
    "重庆": 0.13193287025019643,
    "重庆市": 0.13193287025019643,
    "四川": 0.13408535774660124,
    "成都市": 0.11999960100583136,
    "都江堰市": 0.11950549450549451,
    "彭州市": 0.19807692307692307,
    "邛崃市": 0.19044247787610621,
    "崇州市": 0.13043614116000174,
    "简阳市": 0.24218742748948885,
    "自贡市": 0.16064230976762564,
    "攀枝花市": 0.11492451823201316,
    "泸州市": 0.1304861477198502,
    "德阳市": 0.18600955482375492,
    "广汉市": 0.10084347210265848,
    "什邡市": 0.13127690100430417,
    "绵竹市": 0.10795373021132969,
    "绵阳市": 0.14345047680687487,
    "江油市": 0.07595412671554803,
    "广元市": 0.1688337937074715,
    "遂宁市": 0.1345180330930088,
    "内江市": 0.20491535394470228,
    "隆昌市": 0.1178082191780822,
    "乐山市": 0.11410113505865846,
    "峨眉山市": 0.25162689804772237,
    "南充市": 0.10120481927710843,
    "阆中市": 0.11268629589240277,
    "眉山市": 0.1267838676318511,
    "宜宾市": 0.11437786231399226,
    "广安市": 0.1482446965771345,
    "华蓥市": 0.04285522967724655,
    "达州市": 0.09831613253666487,
    "万源市": 0.385159144174794,
    "雅安市": 0.11856108444893491,
    "巴中市": 0.15452151009657594,
    "资阳市": 0.1812712427237567,
    "马尔康市": 0.23972192256981903,
    "康定市": 0.10478359908883828,
    "西昌市": 0.28959449120122416,
    "贵州": 0.15841435569933787,
    "贵阳市": 0.16267945952119095,
    "清镇市": 0.0006451612903225806,
    "六盘水市": 0.1940227339990573,
    "盘州市": 0.08399272396543883,
    "遵义市": 0.1753720564530043,
    "赤水市": 0.0993010363943119,
    "仁怀市": 0.11355224196277496,
    "安顺市": 0.1658597117915833,
    "毕节市": 0.1965166908563135,
    "铜仁市": 0.15953119940610166,
    "兴义市": 0.14380137386539235,
    "兴仁市": 0.2700078997304319,
    "凯里市": 0.11348405669119334,
    "都匀市": 0.12023826064032546,
    "福泉市": 0.15645617342130066,
    "云南": 0.13860514929125692,
    "昆明市": 0.1459250819612866,
    "安宁市": 0.0535590921080728,
    "曲靖市": 0.1411765305117609,
    "宣威市": 0.10049423393739704,
    "玉溪市": 0.14967448630088875,
    "保山市": 0.08622482361951522,
    "腾冲市": 0.15655250495329748,
    "昭通市": 0.1622596153846154,
    "丽江市": 0.1212335386346262,
    "普洱市": 0.1991011235955056,
    "临沧市": 0.014119601328903655,
    "楚雄市": 0.28688093673457193,
    "个旧市": 0.17591253418870734,
    "开远市": 0.17840516594083197,
    "蒙自市": 0.12511100148001975,
    "弥勒市": 0.08568824065633546,
    "文山市": 0.13957730403945706,
    "景洪市": 0.1703522248353532,
    "大理市": 0.07542338805052273,
    "瑞丽市": 0.0030959752321981426,
    "芒市": 0.1536544850498339,
    "泸水市": 0.024171131611811628,
    "香格里拉市": 0.05513784461152882,
    "西藏": 0.17735407203344014,
    "拉萨市": 0.18800481182333734,
    "日喀则市": 0.16970783371303286,
    "昌都市": 0.14480408858603067,
    "林芝市": 0.15873015873015872,
    "山南市": 0.14168937329700274,
    "那曲市": 0.1897353192296746,
    "陕西": 0.10222556823537442,
    "西安市": 0.09618184313301144,
    "铜川市": 0.10445229681978797,
    "宝鸡市": 0.14316180809831308,
    "咸阳市": 0.04524754412296022,
    "彬州市": 0.12713059079841088,
    "兴平市": 0.24043007966837232,
    "渭南市": 0.10663894252190703,
    "韩城市": 0.19093655589123867,
    "华阴市": 0.12585812356979406,
    "延安市": 0.18611100571550773,
    "汉中市": 0.15610056188730373,
    "榆林市": 0.15625,
    "神木市": 0.09092906774973289,
    "安康市": 0.09272626318711827,
    "商洛市": 0.08035714285714286,
    "杨凌区": 0.07322834645669292,
    "甘肃": 0.08523673561822863,
    "兰州市": 0.06383229971899215,
    "嘉峪关市": 0.1,
    "金昌市": 0.12675099112705304,
    "白银市": 0.16142735768903993,
    "天水市": 0.07435508345978756,
    "武威市": 0.15199887727360256,
    "张掖市": 0.044531123686337916,
    "平凉市": 0.12778146505047683,
    "华亭市": 0.10097087378640776,
    "酒泉市": 0.0917333836858006,
    "玉门市": 0.07733333333333334,
    "敦煌市": 0.14538558786346398,
    "庆阳市": 0.09915427238261884,
    "定西市": 0.10092105263157895,
    "陇南市": 0.10761904761904761,
    "临夏市": 0.10025062656641603,
    "合作市": 0.10416666666666667,
    "青海": 0.13750074968542328,
    "西宁市": 0.15348302054598897,
    "海东市": 0.09560332721183969,
    "玉树市": 0.011865035224323322,
    "格尔木市": 0.12953020134228188,
    "德令哈市": 0.1284414849008322,
    "宁夏": 0.07952482341866857,
    "银川市": 0.02115611482500983,
    "灵武市": 0.05971023589099848,
    "宁东能源化工基地": 0.00186219739292365,
    "石嘴山市": 0.12486236054266303,
    "吴忠市": 0.22569326614633023,
    "青铜峡市": 0.10010971494814416,
    "固原市": 0.07092198581560284,
    "中卫市": 0.16682646212847554,
    "新疆": 0.14164834649208374,
    "乌鲁木齐市": 0.1533744221879815,
    "克拉玛依市": 0.029892229114550882,
    "吐鲁番市": 0.10600923419279662,
    "哈密市": 0.18893805309734513,
    "昌吉市": 0.16448107905582615,
    "阜康市": 0.04793957656635228,
    "博乐市": 0.09909205964892974,
    "阿拉山口市": 0.26194028441389205,
    "库尔勒市": 0.11408229636556068,
    "阿克苏市": 0.09710526315789474,
    "阿图什市": 0.08998875140607424,
    "喀什市": 0.1250446269189575,
    "和田市": 0.10524036379385016,
    "伊宁市": 0.2059005570455952,
    "奎屯市": 0.12783810463968412,
    "霍尔果斯市": 0.05128205128205128,
    "塔城市": 0.16595744680851063,
    "乌苏市": 0.10589702427294836,
    "阿勒泰市": 0.10461538461538461,
    "石河子市": 0.3199409469577138,
    "阿拉尔市": 0.05085488820692679,
    "图木舒克市": 0.045576407506702415,
    "五家渠市": 0.1665213442325159,
    "北屯市": 0.057677610993352654,
    "铁门关市": 0.3043034213824799,
    "双河市": 0.19333333333333333,
    "可克达拉市": 0.007633587786259542,
    "昆玉市": 0.02
}